import { SET_GAMESTEP, SET_GAMESTEP_SUBMITTING, CLEAR_GAMESTEP_SUBMITTING } from '../actions/gameStep.actions';
const initialState = {
  gameStep: null,
  data: null,
  submitting: null
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_GAMESTEP:
      {
        if (!action.payload) {
          return {
            ...state,
            gameStep: null,
            data: null,
            submitting: null
          };
        }
        let nextGameStep = {
          ...state.gameStep
        };
        let nextData = {
          ...state.data
        };
        let nextSubmitting = state.submitting;
        const {
          gameStep,
          data
        } = action.payload;
        if (gameStep && state.gameStep) {
          if (gameStep._id === state.gameStep._id) {
            Object.assign(nextGameStep, gameStep);
          } else {
            nextGameStep = {
              ...gameStep
            };
            nextData = {};
          }
        } else if (gameStep) {
          nextGameStep = {
            ...gameStep
          };
        }
        if (data) {
          Object.assign(nextData, data);
        }
        if (String(state.submitting).split('#')[0] !== String(nextGameStep.updatedAt) || gameStep?._id !== state.gameStep?._id) {
          nextSubmitting = null;
        }
        return {
          ...state,
          gameStep: nextGameStep,
          data: nextData,
          submitting: nextSubmitting
        };
      }
    case SET_GAMESTEP_SUBMITTING:
      return {
        ...state,
        // A unique token, so a timeout from an older submit can't clear a newer one.
        submitting: `${state.gameStep?.updatedAt}#${Date.now()}#${Math.random()}`
      };
    case CLEAR_GAMESTEP_SUBMITTING:
      if (action.payload?.token && action.payload.token !== state.submitting) return state;
      return {
        ...state,
        submitting: null
      };
    default:
      return state;
  }
};